<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <img class="mx-auto h-12 w-auto" src="@/assets/logo.png" alt="Logo" />
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        登录账户
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        或者
        <router-link to="/register" class="font-medium text-green-600 hover:text-green-500">
          注册新账户
        </router-link>
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form class="space-y-6" @submit.prevent="handle_login">
          <div>
            <label for="mobile" class="block text-sm font-medium text-gray-700">
              手机号
            </label>
            <div class="mt-1">
              <input id="mobile" name="mobile" type="tel" autocomplete="tel" required
                v-model="form.mobile"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
                placeholder="请输入手机号" />
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">
              登录密码
            </label>
            <div class="mt-1">
              <input id="password" name="password" type="password" autocomplete="current-password" required
                v-model="form.password"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
                placeholder="请输入密码" />
            </div>
          </div>

          <div>
            <button type="submit" :disabled="loading"
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed">
              <svg v-if="loading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ loading ? '登录中...' : '登录' }}
            </button>
          </div>
        </form>

        <div v-if="error_message" class="mt-4 rounded-md bg-red-50 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">
                {{ error_message }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { httpRequest } from '@/utils/request'

export default {
  name: 'LoginView',
  setup() {
    const router = useRouter()
    const loading = ref(false)
    const error_message = ref('')

    const form = reactive({
      mobile: '',
      password: ''
    })

    const handle_login = async () => {
      loading.value = true
      error_message.value = ''

      try {
        const response = await httpRequest('post', '/v1/auth/login', {
          headers: {
            'Client-Type': '1' // PC端
          },
          body: {
            type: 1, // 密码登录
            mobile: form.mobile,
            password: form.password
          }
        })

        const data = response && response.data ? response.data : null
        if (data && data.access_token) {
          localStorage.setItem('token', data.access_token)

          const can_use_special_diagnosis = !!data.can_use_special_diagnosis
          const can_use_open_diagnosis = !!data.can_use_open_diagnosis
          const can_view_patient_diagnosis_history = !!data.can_view_patient_diagnosis_history

          let cached_profile = null
          try {
            const cached_string = localStorage.getItem('user_profile')
            if (cached_string) cached_profile = JSON.parse(cached_string)
          } catch (e) {
            cached_profile = null
          }

          const next_profile = {
            ...(cached_profile || {}),
            can_use_special_diagnosis,
            can_use_open_diagnosis,
            can_view_patient_diagnosis_history
          }
          localStorage.setItem('user_profile', JSON.stringify(next_profile))

          if (can_use_special_diagnosis) {
            router.push('/doctor/specialized')
          } else if (can_use_open_diagnosis) {
            router.push('/doctor/start')
          } else {
            router.push('/doctor/patients')
          }
        } else {
           error_message.value = '登录失败，请重试'
        }
      } catch (error) {
        error_message.value = error.message || '登录发生错误'
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      loading,
      error_message,
      handle_login
    }
  }
}
</script>
